import React from "react";
import { Pie, Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
} from "chart.js";
import "./style.css";
import Sidebar from "../../Component/SideBar/index.tsx";
import MainLayout from "../../Component/Layout/index.tsx";

// Register ChartJS components
ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale, LinearScale, BarElement);

const Report = () => {
  // Default values (example scenario)
  const totalQuestions = 10;
  const correctAnswers = 7;
  const incorrectAnswers = totalQuestions - correctAnswers;

  // Calculate Pass/Fail based on score
  const passMark = 0.5; // Pass if 50% or more
  const percentage = correctAnswers / totalQuestions;
  const passFail = percentage >= passMark ? "Pass" : "Fail";

  // Data for Pie Chart (correct vs incorrect answers)
  const pieChartData = {
    labels: ["Correct", "Incorrect"],
    datasets: [
      {
        data: [correctAnswers, incorrectAnswers],
        backgroundColor: ["#4CAF50", "#F44336"], // Green for Correct, Red for Incorrect
        borderWidth: 2, // Add border width to pie chart slices
      },
    ],
  };

  // Data for Bar Chart (correct vs incorrect answers)
  const barChartData = {
    labels: ["Correct", "Incorrect"],
    datasets: [
      {
        label: "Answers",
        data: [correctAnswers, incorrectAnswers],
        backgroundColor: ["#4CAF50", "#F44336"], // Green for Correct, Red for Incorrect
        borderColor: ["#388E3C", "#F44336"], // Darker shade for borders
        borderWidth: 2,
        barThickness: 50, // Adjust the thickness of the bars
      },
    ],
  };

  // Function to determine color for Pass/Fail
  const passFailClass = passFail === "Pass" ? "pass" : "fail";

  return (
    <div className="report-container">
      {/* <MainLayout /> */}
      <div className="report-content">
        <h5>Quiz Report</h5>
        
        {/* Table displaying the quiz results */}
        <table className="result-table">
          <thead>
            <tr>
              <th>Metric</th>
              <th>Value</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Total Questions</td>
              <td>{totalQuestions}</td>
            </tr>
            <tr>
              <td>Correct Answers</td>
              <td>{correctAnswers}</td>
            </tr>
            <tr>
              <td>Incorrect Answers</td>
              <td>{incorrectAnswers}</td>
            </tr>
            <tr>
              <td>Pass/Fail</td>
              <td className={passFailClass}><strong>{passFail}</strong></td>
            </tr>
            <tr>
              <td>Your Score</td>
              <td>{correctAnswers} / {totalQuestions}</td>
            </tr>
            <tr>
              <td>Percentage</td>
              <td>{(percentage * 100).toFixed(1)}%</td>
            </tr>
          </tbody>
        </table>

        {/* Container to display both charts in a row */}
        <div className="charts-row">
          <div className="chart-container">
            <h3>Pie Chart of Correct vs Incorrect</h3>
            <Pie data={pieChartData} options={{
              responsive: true,
              plugins: {
                legend: {
                  position: 'top',
                  labels: {
                    font: {
                      size: 16,
                      family: 'Arial, sans-serif',
                      weight: 'bold',
                    },
                  },
                },
                tooltip: {
                  callbacks: {
                    label: function(tooltipItem) {
                      const label = tooltipItem.label || '';
                      const value = tooltipItem.raw;
                      return `${label}: ${value} (${((value / totalQuestions) * 100).toFixed(1)}%)`;
                    },
                  },
                },
              },
            }} />
          </div>

          <div className="chart-container">
            <h3>Bar Graph of Correct vs Incorrect</h3>
            <Bar data={barChartData} options={{
              responsive: true,
              plugins: {
                legend: {
                  position: 'top',
                  labels: {
                    font: {
                      size: 16,
                      family: 'Arial, sans-serif',
                      weight: 'bold',
                    },
                  },
                },
                tooltip: {
                  callbacks: {
                    label: function(tooltipItem) {
                      const label = tooltipItem.dataset.label || '';
                      const value = tooltipItem.raw;
                      return `${label}: ${value} answers`;
                    },
                  },
                },
              },
              scales: {
                y: {
                  beginAtZero: true,
                  ticks: {
                    stepSize: 1, // Add a step size for better scaling
                  },
                },
              },
            }} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Report;
